import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLenis } from "lenis/react";
import { api } from "@/lib/api";
import { useContent } from "@/context/ContentContext";
import SEO from "@/components/SEO";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import SelectedWork from "@/components/site/SelectedWork";
import Manifesto from "@/components/site/Manifesto";
import Journal from "@/components/site/Journal";
import Ribbon from "@/components/site/Ribbon";
import Closing from "@/components/site/Closing";

export default function Home() {
  const content = useContent();
  const [projects, setProjects] = useState([]);
  const lenis = useLenis();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/projects", { params: { featured: true } }).then(({ data }) => {
      setProjects(data.length ? data : []);
    });
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el && lenis) lenis.scrollTo(el, { offset: -20 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  if (!content) return <div className="min-h-screen bg-background" />;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "InteriorDesignBusiness",
    name: content.brand?.name || "Nat Habitat",
    description: content.seo?.description,
    image: content.seo?.og_image,
    url: "https://nathabitat.com",
    address: { "@type": "PostalAddress", addressLocality: "Dubai", addressCountry: "AE" },
    founder: content.founder?.name,
  };

  return (
    <div className="bg-background">
      <SEO
        title={content.seo?.title}
        description={content.seo?.description}
        image={content.seo?.og_image}
        jsonLd={jsonLd}
      />
      <Nav brand={content.brand?.name} />
      <main>
        <Hero
          data={content.hero}
          onCtaPrimary={() => navigate("/projects")}
          onCtaSecondary={() => navigate("/lets-begin")}
        />
        <About data={content.about} founder={content.founder} />
        <SelectedWork data={content.work} projects={projects} />
        <Manifesto data={content.manifesto} />
        <Ribbon text={content.marquee?.text} />
        <Journal data={content.journal} />
        <Closing data={content.closing} onCta={() => navigate("/lets-begin")} />
      </main>
      <Footer content={content} />
    </div>
  );
}
